import 'swiper/css';
import 'swiper/css/navigation';

import { trackGA4ViewItemList } from '@/common/analytics/gtm/item/trackViewItemList';
import { ACRONYMS, EventMessage } from '@/common/analytics/gtm/types';
import SliderWithImpressions from '@/common/components/Slider/SliderWithImpressions';
import { convertRecentlyViewedForGalleryItem } from '@/common/components/SliderArtworkItem/SliderArtworkItem.converter';
import SliderArtworkItemWithAnalytics from '@/common/components/SliderArtworkItem/SliderArtworkItemWithAnalytics';
import { ImpressionsContextProvider } from '@/common/impressions';
import { useCurrentPage } from '@/common/routes/ElysiumKnownPages';
import { RecentlyViewedProductV3 } from '@/common/utils/recentlyViewed/recentlyViewed';

import styles from './RecentlyViewed.module.scss';

interface RecentlyViewedSliderProps {
  items: RecentlyViewedProductV3[];
}

const RecentlyViewedSlider = ({ items }: RecentlyViewedSliderProps) => {
  const pageConfig = useCurrentPage();
  return (
    <ImpressionsContextProvider<EventMessage> callback={trackGA4ViewItemList}>
      <SliderWithImpressions
        keyExtractor={(item) => item.id}
        metadata={{ elementVariant: 'recently_viewed' }}
        renderSlide={(item, index, useSlideImpression) => (
          <SliderArtworkItemWithAnalytics
            index={index}
            item={convertRecentlyViewedForGalleryItem(item)}
            metadata={{
              athenaPageName: pageConfig.analyticsAthenaName,
              gaPageName: pageConfig.analyticsGaName,
              itemListName: 'Recently Viewed',
              listingFunction: ACRONYMS.RECENTLY_VIEWED,
              listingType: 'slider',
            }}
            useSlideImpression={useSlideImpression}
          />
        )}
        slideClassName={styles.slide}
        slides={items}
      />
    </ImpressionsContextProvider>
  );
};

export default RecentlyViewedSlider;
